import { Box } from '@mui/material';

export type StatusDotVariant = 'success' | 'warning' | 'error' | 'default';

type StatusDotProps = {
  variant: StatusDotVariant;
};

export const StatusDot = ({ variant }: StatusDotProps) => (
  <Box
    component='span'
    data-testid='status-dot'
    data-variant={variant}
    sx={(theme) => ({
      display: 'inline-block',
      width: 8,
      height: 8,
      borderRadius: '50%',
      flexShrink: 0,
      backgroundColor:
        variant === 'default' ? theme.palette.text.disabled : theme.palette[variant].main,
    })}
  />
);
